import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=71edb88a&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=ts&"
export * from "./Card.vue?vue&type=script&lang=ts&"
import style0 from "./Card.vue?vue&type=style&index=0&id=71edb88a&lang=less&scoped=true&"
import style1 from "./Card.vue?vue&type=style&index=1&id=71edb88a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edb88a",
  null
  
)

export default component.exports